module.exports = __webpack_public_path__ + "img/marker_one_green3.b83947da.png";